import client from './index';

export default {
  async getLanguages(byPass = true) {
    const defaultLanguage = [
      {id: 'en-US', name: 'ENG'},
      {id: 'zh-HK', name: '中'},
    ];

    if (typeof window === 'undefined' && byPass) {
      return defaultLanguage;
    } else {
      try {
        const response = await client.get('/v1/language');
        return response.data;
      } catch (e) {
        return defaultLanguage;
      }
    }
  },
};
